import * as yup from 'yup';

/**
 * Esquemas de validación Yup para formularios
 * Centralizados para reutilización y mantenibilidad
 */

// Esquema de Login
export const loginSchema = yup.object({
  email: yup
    .string()
    .required('El email es requerido')
    .email('Email inválido')
    .trim(),
  password: yup
    .string()
    .required('La contraseña es requerida')
    .min(6, 'La contraseña debe tener al menos 6 caracteres'),
});

// Esquema de Forgot Password
export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required('El email es requerido')
    .email('Email inválido')
    .trim(),
});

// Esquema de Reset Password
export const resetPasswordSchema = yup.object({
  newPassword: yup
    .string()
    .required('La nueva contraseña es requerida')
    .min(6, 'La contraseña debe tener al menos 6 caracteres'),
  confirmPassword: yup
    .string()
    .required('Confirmar contraseña es requerido')
    .oneOf([yup.ref('newPassword')], 'Las contraseñas no coinciden'),
});

// Esquema de Usuario (Crear)
export const crearUsuarioSchema = yup.object({
  nombre: yup
    .string()
    .required('El nombre es requerido')
    .trim()
    .min(2, 'Mínimo 2 caracteres'),
  apellido: yup
    .string()
    .required('El apellido es requerido')
    .trim()
    .min(2, 'Mínimo 2 caracteres'),
  email: yup
    .string()
    .required('El email es requerido')
    .email('Email inválido')
    .trim(),
  password: yup
    .string()
    .required('La contraseña es requerida')
    .min(6, 'Mínimo 6 caracteres'),
  rol: yup
    .string()
    .required('El rol es requerido')
    .oneOf(['cliente', 'entrenador', 'admin'], 'Rol inválido'),
  telefono: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  rut: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  fechaNacimiento: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .max(new Date(), 'La fecha no puede ser futura'),
  preferenciasHorario: yup
    .array()
    .of(
      yup.object({
        dia: yup.string().oneOf(['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'], 'Día inválido').required('Día requerido'),
        horaInicio: yup.string().matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato de hora inválido (HH:MM)').required('Hora de inicio requerida'),
        horaFin: yup.string().matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato de hora inválido (HH:MM)').required('Hora de fin requerida')
      })
    )
    .test('no-duplicados', 'No puede haber horarios duplicados (mismo día y horario)', function(preferencias) {
      if (!preferencias || preferencias.length === 0) return true;
      
      const vistos = new Set();
      for (const pref of preferencias) {
        if (!pref.dia || !pref.horaInicio || !pref.horaFin) continue;
        const clave = `${pref.dia}-${pref.horaInicio}-${pref.horaFin}`;
        if (vistos.has(clave)) {
          return false;
        }
        vistos.add(clave);
      }
      return true;
    })
    .default([]),
  activo: yup.boolean().default(true),
});

// Esquema de Usuario (Editar) - password opcional
export const editarUsuarioSchema = yup.object({
  nombre: yup
    .string()
    .required('El nombre es requerido')
    .trim()
    .min(2, 'Mínimo 2 caracteres'),
  apellido: yup
    .string()
    .required('El apellido es requerido')
    .trim()
    .min(2, 'Mínimo 2 caracteres'),
  email: yup
    .string()
    .required('El email es requerido')
    .email('Email inválido')
    .trim(),
  password: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value))
    .min(6, 'Mínimo 6 caracteres'),
  rol: yup
    .string()
    .required('El rol es requerido')
    .oneOf(['cliente', 'entrenador', 'admin'], 'Rol inválido'),
  telefono: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  rut: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)),
  fechaNacimiento: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .max(new Date(), 'La fecha no puede ser futura'),
  preferenciasHorario: yup
    .array()
    .of(
      yup.object({
        dia: yup.string().oneOf(['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'], 'Día inválido').required('Día requerido'),
        horaInicio: yup.string().matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato de hora inválido (HH:MM)').required('Hora de inicio requerida'),
        horaFin: yup.string().matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato de hora inválido (HH:MM)').required('Hora de fin requerida')
      })
    )
    .test('no-duplicados', 'No puede haber horarios duplicados (mismo día y horario)', function(preferencias) {
      if (!preferencias || preferencias.length === 0) return true;
      
      const vistos = new Set();
      for (const pref of preferencias) {
        if (!pref.dia || !pref.horaInicio || !pref.horaFin) continue;
        const clave = `${pref.dia}-${pref.horaInicio}-${pref.horaFin}`;
        if (vistos.has(clave)) {
          return false;
        }
        vistos.add(clave);
      }
      return true;
    })
    .default([]),
  activo: yup.boolean().default(true),
});
